import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, logout, fetchUserInfo as fetchUserInfoFromAuth } from '../utils/auth';
import Login from './Login';
import './TradingHeader.css';

import { TRADING_TABS } from './Trading/utils';

const TAB_MENUS = TRADING_TABS;

function TradingHeader({ onOpenProfile }) {
  const [user, setUser] = useState(null);
  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showFeatures, setShowFeatures] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 사용자 정보 조회
    const token = getToken();
    if (token) {
      fetchUserInfo();
    } else {
      setUser(null);
    }
  }, []);

  // 사용자 정보 조회
  const fetchUserInfo = async () => {
    try {
      const token = getToken();
      if (!token) {
        setUser(null);
        setIsLoadingUser(false);
        return;
      }

      setIsLoadingUser(true);
      const userData = await fetchUserInfoFromAuth(false); // 캐시 사용
      if (userData) {
        setUser(userData);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('사용자 정보 조회 실패:', error);
      setUser(null);
    } finally {
      setIsLoadingUser(false);
    }
  };

  // 로그인 성공 핸들러
  const handleLoginSuccess = (userData) => {
    setUser(userData);
    setShowLogin(false);
    // 페이지 새로고침하여 모든 데이터 다시 로드
    window.location.reload();
  };

  // 로그아웃 핸들러
  const handleLogout = () => {
    logout();
    setUser(null);
    setShowUserMenu(false);
    window.location.reload();
  };

  // 사용자 메뉴 / 소개/기능 / 모바일 메뉴 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserMenu && !event.target.closest('.trading-header-user-info')) {
        setShowUserMenu(false);
      }
      if (showFeatures && !event.target.closest('.trading-header-features')) {
        setShowFeatures(false);
      }
      if (showMobileMenu && !event.target.closest('.trading-header-mobile-menu-wrap')) {
        setShowMobileMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showUserMenu, showFeatures, showMobileMenu]);

  return (
    <header className="trading-header">
      <div className="trading-header-content">
        {/* 좌측: 소개/기능 */}
        <div className="trading-header-left">
          <div className="trading-header-features" style={{ position: 'relative' }}>
            <button
              className="features-button"
              onClick={() => setShowFeatures(!showFeatures)}
            >
              소개/기능
              <span className="dropdown-arrow">▼</span>
            </button>
            {showFeatures && (
              <div className="features-dropdown">
                <button onClick={() => {
                  setShowFeatures(false);
                  // 소개 탭으로 이동
                  const introTab = document.querySelector('.trading-tabs button:first-child');
                  if (introTab) {
                    introTab.click();
                  }
                  // 또는 직접 탭 변경
                  if (window.setTradingTab) {
                    window.setTradingTab('intro');
                  }
                }}>
                  서비스 소개
                </button>
                <button onClick={() => {
                  setShowFeatures(false);
                  // 소개 탭으로 이동 후 기능 섹션으로 스크롤
                  const introTab = document.querySelector('.trading-tabs button:first-child');
                  if (introTab) {
                    introTab.click();
                    setTimeout(() => {
                      const featuresSection = document.querySelector('.intro-features');
                      if (featuresSection) {
                        featuresSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }, 100);
                  }
                }}>
                  주요 기능
                </button>
                <button onClick={() => {
                  setShowFeatures(false);
                  // AI 거래 탭으로 이동
                  const aiTab = document.querySelector('.trading-tabs button[data-tab="ai-trade"]');
                  if (aiTab) {
                    aiTab.click();
                  } else {
                    // 직접 탭 변경
                    if (window.setTradingTab) {
                      window.setTradingTab('ai-trade');
                    }
                  }
                }}>
                  AI 거래
                </button>
              </div>
            )}
          </div>
        </div>

        {/* 센터: 타이틀 */}
        <div className="trading-header-center">
          <h1 className="trading-header-title">AI주식거래서비스-제우스</h1>
        </div>

        {/* 우측: 모바일 햄버거 + 로그인 */}
        <div className="trading-header-right">
          <div className="trading-header-mobile-menu-wrap">
            <button
              type="button"
              className="trading-header-hamburger-btn"
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              aria-label="메뉴"
            >
              <span />
              <span />
              <span />
            </button>
            {showMobileMenu && (
              <div className="trading-header-mobile-dropdown">
                {TAB_MENUS.map(({ id, label }) => (
                  <button
                    key={id}
                    type="button"
                    className="trading-header-mobile-menu-item"
                    onClick={() => {
                      if (window.setTradingTab) window.setTradingTab(id);
                      setShowMobileMenu(false);
                    }}
                  >
                    <span className="trading-header-mobile-menu-arrow">&gt;</span>
                    {label}
                  </button>
                ))}
                {!user && (
                  <>
                    <div className="trading-header-mobile-auth-divider" />
                    <button
                      type="button"
                      className="trading-header-mobile-auth-btn login"
                      onClick={() => {
                        setShowMobileMenu(false);
                        setShowLogin(true);
                      }}
                    >
                      <span className="trading-header-mobile-menu-arrow">&gt;</span>
                      로그인
                    </button>
                    <button
                      type="button"
                      className="trading-header-mobile-auth-btn register"
                      onClick={() => {
                        setShowMobileMenu(false);
                        setShowLogin(true);
                        setTimeout(() => {
                          const registerTab = document.querySelector('.login-tabs button:last-child');
                          if (registerTab) registerTab.click();
                        }, 100);
                      }}
                    >
                      <span className="trading-header-mobile-menu-arrow">&gt;</span>
                      회원가입
                    </button>
                  </>
                )}
                {user && (
                  <>
                    <div className="trading-header-mobile-auth-divider" />
                    <div className="trading-header-mobile-user-email">{user.email}</div>
                    <button
                      type="button"
                      className="trading-header-mobile-auth-btn logout"
                      onClick={() => {
                        setShowMobileMenu(false);
                        handleLogout();
                      }}
                    >
                      <span className="trading-header-mobile-menu-arrow">&gt;</span>
                      로그아웃
                    </button>
                    <button
                      type="button"
                      className="trading-header-mobile-auth-btn"
                      onClick={() => {
                        setShowMobileMenu(false);
                        if (typeof onOpenProfile === 'function') {
                          onOpenProfile();
                        } else {
                          const profileTab = document.querySelector('[data-tab="profile"]');
                          if (profileTab) profileTab.click();
                        }
                      }}
                    >
                      <span className="trading-header-mobile-menu-arrow">&gt;</span>
                      프로필
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          {isLoadingUser ? (
            <div className="loading-text">로딩 중...</div>
          ) : user ? (
            <div className="trading-header-user-info" style={{ position: 'relative' }}>
              <button
                className="user-menu-button"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <span className="user-name">👤 {user.nickname || user.name || '사용자'}</span>
                <span className="dropdown-arrow">▼</span>
              </button>
              {showUserMenu && (
                <div className="user-menu-dropdown">
                  <div className="user-email">{user.email}</div>
                  <button onClick={() => {
                    setShowUserMenu(false);
                    if (typeof onOpenProfile === 'function') {
                      onOpenProfile();
                    } else {
                      const profileTab = document.querySelector('[data-tab="profile"]');
                      if (profileTab) profileTab.click();
                    }
                  }}>
                    프로필
                  </button>
                  <button onClick={handleLogout} className="logout-button">
                    로그아웃
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <button
                className="login-button"
                onClick={() => setShowLogin(true)}
                style={{
                  marginRight: '10px',
                  padding: '8px 16px',
                  background: 'transparent',
                  border: '1px solid #667eea',
                  color: '#667eea',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#667eea';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#667eea';
                }}
              >
                로그인
              </button>
              <button
                className="register-button"
                onClick={() => {
                  setShowLogin(true);
                  // Login 컴포넌트에서 회원가입 탭으로 전환하도록 처리
                  setTimeout(() => {
                    const registerTab = document.querySelector('.login-tabs button:last-child');
                    if (registerTab) registerTab.click();
                  }, 100);
                }}
                style={{
                  padding: '8px 16px',
                  background: '#667eea',
                  border: '1px solid #667eea',
                  color: '#fff',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#5568d3';
                  e.target.style.borderColor = '#5568d3';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#667eea';
                  e.target.style.borderColor = '#667eea';
                }}
              >
                회원가입
              </button>
            </>
          )}
        </div>
      </div>

      {/* 로그인 모달 */}
      {showLogin && (
        <Login
          onLoginSuccess={handleLoginSuccess}
          onClose={() => setShowLogin(false)}
        />
      )}
    </header>
  );
}

export default TradingHeader;
